var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2851 33.696C12.2851 36.6307 9.88776 39.028 6.9531 39.028C4.01843 39.028 1.62109 36.6307 1.62109 33.696C1.62109 30.7613 4.01843 28.364 6.9531 28.364H12.2851V33.696Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9717 33.696C14.9717 30.7613 17.369 28.364 20.3037 28.364C23.2383 28.364 25.6357 30.7613 25.6357 33.696V47.0467C25.6357 49.9813 23.2383 52.3787 20.3037 52.3787C17.369 52.3787 14.9717 49.9813 14.9717 47.0467V33.696Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3037 12.2853C17.369 12.2853 14.9717 9.88801 14.9717 6.95334C14.9717 4.01867 17.369 1.62134 20.3037 1.62134C23.2383 1.62134 25.6357 4.01867 25.6357 6.95334V12.2853H20.3037Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3038 14.9719C23.2384 14.9719 25.6358 17.3693 25.6358 20.3039C25.6358 23.2386 23.2384 25.6359 20.3038 25.6359H6.9531C4.01843 25.6359 1.62109 23.2386 1.62109 20.3039C1.62109 17.3693 4.01843 14.9719 6.9531 14.9719H20.3038Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7144 20.3039C41.7144 17.3693 44.1117 14.9719 47.0464 14.9719C49.981 14.9719 52.3784 17.3693 52.3784 20.3039C52.3784 23.2386 49.981 25.6359 47.0464 25.6359H41.7144V20.3039Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0278 20.304C39.0278 23.2387 36.6304 25.636 33.6958 25.636C30.7611 25.636 28.3638 23.2387 28.3638 20.304V6.95334C28.3638 4.01867 30.7611 1.62134 33.6958 1.62134C36.6304 1.62134 39.0278 4.01867 39.0278 6.95334V20.304Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6958 41.7146C36.6304 41.7146 39.0278 44.1119 39.0278 47.0466C39.0278 49.9813 36.6304 52.3786 33.6958 52.3786C30.7611 52.3786 28.3638 49.9813 28.3638 47.0466V41.7146H33.6958Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6958 39.028C30.7611 39.028 28.3638 36.6307 28.3638 33.696C28.3638 30.7613 30.7611 28.364 33.6958 28.364H47.0464C49.9811 28.364 52.3784 30.7613 52.3784 33.696C52.3784 36.6307 49.9811 39.028 47.0464 39.028H33.6958Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slackLogo.4792fa78cba3cfba730249fc74b2062a.svg";
export { ForwardRef as ReactComponent };